export default "__VITE_ASSET__Bmq0mNv0__"